/**
 * LoginNetwork 브랜드 마크(로그인네트웍 로고, logins.kr 과 같은 것) — loginHS 로고 통합(2026-10-02).
 * 원본: 개발팀2/거래처별작업내용2/통합/로고/01.Logo (Loginnw_logo_220412). 색은 가이드 그대로
 * Main #FED100 · Sub Main #1A1A1A · Sub #F1F1F1.
 *  - tone="light": 밝은 바탕용(검은 틀 + 노란 문)
 *  - tone="dark":  어두운 바탕용(옅은 틀 50% + 노란 문)
 */
import React from "react";

const FRAME = "M.6,150V28C.6,12.535,12.577,0,28.1,0H150.6V150ZM125.913,25H34.135A8.017,8.017,0,0,0,26.1,33v92h99.811Z";
const DOOR = "M1.777,127.142A3.014,3.014,0,0,1,0,124.285V25.714a3.884,3.884,0,0,1,1.777-2.857L47.99,0V150Z";

export default function BrandMark({ size = 24, tone = "light", title, style }) {
  const dark = tone === "dark";
  return (
    <svg width={size} height={size} viewBox="0 0 150 150" role={title ? "img" : undefined}
      aria-label={title} aria-hidden={title ? undefined : true} style={{ flexShrink: 0, display: "block", ...style }}>
      <path d={FRAME} transform="translate(-0.6)" fill={dark ? "#f1f1f1" : "#1a1a1a"} fillRule="evenodd" opacity={dark ? 0.5 : 1} />
      <path d={DOOR} transform="translate(102.01)" fill="#fed100" fillRule="evenodd" />
    </svg>
  );
}
